import React from 'react'

import { Form, Col } from '_zari/core'

const FechaEmisionFormGroup = ({ onChange, value }) => {
  return (
    <Form.Group>
      <Form.Label text='FEC. EMISION' htmlFor='input-fechaEmision' md={4} />
      <Col md={8}>
        <Form.InputDate
          id='input-fechaEmision'
          placeholder='Ingresar fecha ...'
          onChange={onChange}
          value={value}
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaEmisionFormGroup)
